// this is an autogenerated file from App/Account/Content/Settings/Content/CommsEmail/Emails/Emails/Content/Email/Edit/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_CommsEmail_Emails_Emails_Content_Email_Edit($email: String!, $id: uuid!) {
  update_comms_outbound_emails_by_pk(
    pk_columns: { id: $id }
    _set: { email: $email }
  ) {
    id
  }
}

`